enum ValidityHint {
  Failure = 'FAILURE',
  Success = 'SUCCESS',
  Warning = 'WARNING',
  None = 'NONE',
}

export default ValidityHint;
